export default "__VITE_ASSET__CKi5gjr7__"